import { PlayerMetricHeuristic } from '../../jscaip/AI/PlayerMetricHeuristic';
export class AbaloneScoreHeuristic extends PlayerMetricHeuristic {
    getMetrics(node, _config) {
        return node.gameState.getScores().toTable();
    }
}
